module.exports = __webpack_public_path__ + "static/img/loading.60ef936.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loading.gif
// module id = J2Sg
// module chunks = 1